import { InjectionToken } from '@angular/core';
export var /** @type {?} */ AMD_MEDIA_QUERY = new InjectionToken('AmdMediaQuery');
//# sourceMappingURL=media-query.token.js.map
//# sourceMappingURL=media-query.token.js.map
